<template>
  <div v-if="loadingPrecio">
    <SpringSpinner color="blue" :size="12" :animation-duration="500"/>
  </div>
  <div class="precios" v-else>
    {{ precio | currency }}
  </div>
</template>

<script>
  import SpringSpinner from "epic-spinners/src/components/lib/SpringSpinner";

  export default {
    components: {SpringSpinner},
    name: "Precio",
    props: {
      precio: 0,
      loadingPrecio: false
    }
  }
</script>

<style scoped>
  .precios{
    animation: fadeIn 200ms linear;
  }
  @keyframes fadeIn {
    to {
      opacity: 1;
    }
    from {
      opacity: 0;
    }
  }
</style>
